import { ToastContainer } from 'react-toastify';
import { Outlet } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';

import { useTheme } from '@mui/material';

import AppWrapper from '@common/ui/AppWrapper';

import AppSidebar from '@common/ui/AppSidebar';
import AppSidebarItem from '@common/ui/AppSidebarItem';
import { aponoColors } from '@common/utils/colors';

import Navigation from './organisms/Sidebar';
import User from './organisms/User';

import Brand from './components/Brand';
import Logo from './components/Logo';

const MINIMIZED_KEY = 'sidebar-minimized';

export default function AppLayout() {
  const [minimized, setMinimized] = useLocalStorage(MINIMIZED_KEY, false);

  return (
    <AppWrapper
      minimizedSidebar={minimized}
      sidebar={
        <AppSidebar
          header={
            <AppSidebarItem
              minimized={minimized}
              icon={<Logo fill={aponoColors.primary[400]} />}
              label={<Brand fill={aponoColors.white} />}
              enableAnimation
            />
          }
          footer={<User minimized={minimized} />}
          minimized={minimized}
          onMinimizeToggle={() => setMinimized((p) => !p)}
        >
          <Navigation minimized={minimized} />
        </AppSidebar>
      }
    >
      <Outlet />
      <Notificator />
    </AppWrapper>
  );
}

function Notificator() {
  const theme = useTheme();
  return (
    <ToastContainer position="bottom-left" hideProgressBar theme={theme.palette.mode === 'dark' ? 'dark' : 'light'} />
  );
}
